export default __webpack_public_path__ + "static/media/team-1.251f2f4d.jpg";